type Font = {
  fontWeights: {
    lighter: string;
    normal: string;
    semibold: string;
    bold: string;
  };
  fontSizes: string[];
  fonts: { [key: string]: string };
};

export type FontWeight = keyof Font['fontWeights'];

export const font: Font = {
  fontSizes: [
    '1rem', // 0
    '1.1rem', // 1
    '1.2rem', // 2
    '1.3rem', // 3
    '1.4rem', // 4
    '1.5rem', // 5
    '1.6rem', // 6
    '1.8rem', // 7
    '2rem', // 8
    '2.1rem', // 9
    '2.2rem', // 10
    '2.3rem', // 11
    '2.4rem', // 12
    '2.5rem', // 13
    '2.6rem', // 14
    '2.8rem', // 15
    '3.2rem', // 16
  ],
  fontWeights: {
    lighter: '300',
    normal: '400',
    semibold: '600',
    bold: '700',
  },
  fonts: {
    brand: 'Roboto, Geneva, Verdana, sans-serif',
    brandSecondary: '"Roboto Slab", Georgia, serif',
  },
};
